import { render, staticRenderFns } from "./HelperDetails.vue?vue&type=template&id=a503813c&"
import script from "./HelperDetails.vue?vue&type=script&lang=js&"
export * from "./HelperDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports